<template>
    <div id="dody">
        <searchpub
            :type="type"
            :search-type="searchType"
            :searchVal="searchVal"
            ref="child"
            v-on:child-say="listenToMyBoy"
            v-on:listen-val="listenVal"
            v-on:listen-type="listenType"
        ></searchpub>
        <router-link to="/advanced" class="adv"> 高级检索 >> </router-link>
        <div class="top">
            <ul class="top-list">
                <li :class="['group', { isLi: folderFollowBtn }]" @click="showPopUp('left')">
                    <img src="../../assets/pubMed/shaixuan.png" alt="" /> 筛选
                </li>
                <li :class="['sort', { isLi: folderFollowBtn }]" @click="showPopUp('right')">
                    <img src="../../assets/pubMed/guolv.png" alt="" /> 过滤
                </li>
                <li class="follow" v-if="folderFollowBtn" @click="folderFollow()">
                    添加跟踪式检索 > >
                </li>
            </ul>
        </div>
        <div class="search_list" v-if="yanNull">
            <ul>
                <li>
                    <p class="count">为您检索到{{ count }}条数据</p>
                </li>
                <li v-for="(item, i) in data" v-bind:key="i" class="search_single">
                    <p class="title">
                        <!--touchend-->
                        <span class="hold">{{ i + 1 }}. </span><span v-html="item.title">{{ item.title }}</span>
                    </p>
                    <p class="common author">
                        <!--      <span class="hold">来源:</span> --><span class="author-a" v-html="item.source">{{ item.source }}</span>
                    </p>
                    <p class="common author">
                        <span class="hold">pmid:</span>
                        <span class="author-a" v-html="item.pmid">{{ item.pmid }}</span>
                    </p>
                    <p class="caozuo">
                        <span
                            @click="viewDescription(item.pmid)"
                            :class="contentId === item.pmid && detailsType === 'viewDescription' ? 'detailActive' : ''"
                            >查看摘要</span
                        >
                        <span
                            @click="journalBlock(item.pmid, 'qkfq')"
                            :class="contentId === item.pmid && detailsType === 'qkfq' ? 'detailActive' : ''"
                            >期刊分区</span
                        >
                        <span
                            @click="journalBlock(item.pmid, 'scics')"
                            :class="contentId === item.pmid && detailsType === 'scics' ? 'detailActive' : ''"
                            >CiteScore</span
                        >
                        <span
                            v-if="item.caseFlag != 1"
                            @click="ApplicationFullText(i)"
                            :class="contentId === item.pmid && detailsType === 'ApplicationFullText' ? 'detailActive' : ''"
                            >申请全文</span
                        >
                    </p>
                    <div class="content2" v-if="contentId === item.pmid">
                        <div class="content_single" v-if="detailsType === 'viewDescription'">
                            <p v-html="detailsArr ? detailsArr : '（空）'">
                                {{ detailsArr ? detailsArr : "（空）" }}
                            </p>
                        </div>
                        <div class="content_single" v-if="detailsType === 'qkfq'">
                            <div v-if="detailsArr != undefined">
                                <p class="listTabModular">分区信息</p>
                                <div v-if="detailsArr.dalei">
                                    <p>
                                        <span>中科院大类分区:</span>
                                        <span> {{ detailsArr.dalei }} </span>
                                        <span class="qkfqSpan">该大类分区的期刊数量:</span>
                                        <span> {{ detailsArr.daleiCount }} </span>
                                    </p>
                                    <p>
                                        <span>中科院小类分区:</span><span> {{ detailsArr.xiaolei }} </span>
                                    </p>
                                    <p>
                                        <span>是否TOP期刊:</span><span> {{ detailsArr.topFlag }} </span>
                                    </p>
                                </div>
                                <p v-else>
                                    暂未找到分区信息
                                </p>
                                <p class="listTabModular">期刊信息:</p>
                                <p>
                                    <span>Title(s):</span><span> {{ detailsArr.title }}</span>
                                </p>
                                <p>
                                    <span>Country of Publication:</span><span> {{ detailsArr.country }}</span>
                                </p>
                                <p>
                                    <span>Frequency:</span><span> {{ detailsArr.frequency }}</span>
                                </p>
                                <p>
                                    <span>Publisher:</span><span> {{ detailsArr.publisher }}</span>
                                </p>
                                <p>
                                    <span>Electronic Links:</span
                                    ><a target="_blank" class="linka" :href="detailsArr.links"> {{ detailsArr.links }}</a>
                                </p>
                            </div>
                            <p v-else>
                                （空）
                            </p>
                        </div>

                        <div class="content_single" v-if="detailsType === 'scics' && detailsArr != ''">
                            <div v-if="detailsArr != undefined">
                                <div v-if="flag == 1">
                                    <p>Title:{{ detailsArr.wosJournaltitle }}</p>
                                    <p>Abbr Journal:{{ detailsArr.wosAbbrjournal }}</p>
                                    <p>Issn:{{ detailsArr.wosIssn }}</p>
                                    <p>Impact Factor:{{ detailsArr.wosJournalimpactfactor }}</p>
                                    <!-- <p>5Year Impact:{{ detailsArr.wos5yearimpactfactor }}</p>
                                    <p>Publisher Name:{{ detailsArr.wosPublishername }}</p>
                                    <p>Countrye:{{ detailsArr.wosCountry }}</p>
                                    <p>Jour Type:{{ detailsArr.wosJourtype }}</p> -->
                                </div>
                                <div v-else-if="flag == 2">
                                    <p>Title:{{ detailsArr.sjrTitle }}</p>
                                    <p>SJR指数:{{ detailsArr.sjrSjr }}</p>
                                    <p>CiteScore:{{ detailsArr.sjrCitescore }}</p>
                                    <p>Year:{{ detailsArr.year }}</p>
                                    <p>SNIP:{{ detailsArr.sjrSnip }}</p>
                                    <p>Scopus SubSubject Area:Medicine: {{ detailsArr.sjrScopusSubSubjectArea }}</p>
                                    <p>Type:{{ detailsArr.sjrType }}</p>
                                    <p>Publisher:{{ detailsArr.sjrPublisher }}</p>
                                    <!-- <p>[title]:{{ detailsArr.sjrTitle }}</p>
                                    <p>[CiteScore]:{{ detailsArr.sjrCitescore }}</p>
                                    <p>[Citation Count]:{{ detailsArr.sjrCitationCount }}</p>
                                    <p> SJR指数:{{ detailsArr.sjr }} </p>
                                    <p>[Scopus ASJC Code]:{{ detailsArr.sjrScopusAsjcCodeSubSubjectArea }}</p>
                                    <p>[Percent Cited]:{{ detailsArr.sjrPercentCited }}</p>
                                    <p>[Scopus SubSubject Area]:{{ detailsArr.sjrScopusSubSubjectArea }}</p>
                                    <p>[Type]:{{ detailsArr.sjrType }}</p>
                                    <p>[Percentile]:{{ detailsArr.sjrPercentile }}</p>
                                    <p>[Publisher]:{{ detailsArr.sjrPublisher }}</p> -->
                                </div>
                            </div>
                            <p v-else>
                                （空）
                            </p>
                        </div>
                        <div class="content_single" v-if="detailsType === 'scics' && detailsArr == ''">
                            <p style="text-align:center">暂无数据</p>
                        </div>
                        <div class="content_single" v-if="detailsType === 'ApplicationFullText'">
                            <p>{{ toTest }}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!--暂无数据-->
        <div class="zanwu" v-else>暂无数据</div>
        <!--左侧过滤菜单-->
        <md-popup v-model="isPopupShow.left" position="left">
            <div class="md-example-popup md-example-popup-left dempo_box">
                <div class="dempo">
                    <div class="left-title">筛选</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="textAvailabilityImgShow = !textAvailabilityImgShow">
                                <p class="saixuan_tit">TEXT AVAILABILITY</p>
                                <img :src="textAvailabilityImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="textAvailabilityImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in textAvailability" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="textAvailability"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="textAvailabilitySingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="articleAttributeImgShow = !articleAttributeImgShow">
                                <p class="saixuan_tit">
                                    ARTICLE ATTRIBUTE
                                </p>
                                <img :src="articleAttributeImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="articleAttributeImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in articleAttribute" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="articleAttribute"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="articleAttributeSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="languageImgShow = !languageImgShow">
                                <p class="saixuan_tit">LANGUAGE</p>
                                <img :src="languageImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="languageImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in language" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="language"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="languageSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="articleTypeImgShow = !articleTypeImgShow">
                                <p class="saixuan_tit">ARTICLE TYPE</p>
                                <img :src="articleTypeImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="articleTypeImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in articleType" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="articleType"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="articleTypeSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="publicationDateImgShow = !publicationDateImgShow">
                                <p class="saixuan_tit">PUBLICATION DATE</p>
                                <img :src="publicationDateImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="publicationDateImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in publicationDate" :key="item.name">
                                    <input
                                        type="radio"
                                        class="check_box tui-checkbox dan"
                                        name="publicationDate"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="publicationDateSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                                <!-- <md-button @click="showPopUp('bottom')">底部弹出</md-button> -->
                                <div v-show="dateShow" class="dateDiv">
                                    <div @click="showPopUp('bottoms')">{{ yearStart }}</div>
                                    -
                                    <div @click="showPopUp('bottome')">{{ yearEnd }}</div>
                                </div>

                                <!-- <md-button @click="showPopUp()">底部弹出</md-button> -->
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="sexImgShow = !sexImgShow">
                                <p class="saixuan_tit">SEX</p>
                                <img :src="sexImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="sexImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in sex" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="sex"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="sexSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="journalImgShow = !journalImgShow">
                                <p class="saixuan_tit">
                                    JOURNAL
                                </p>
                                <img :src="journalImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="journalImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in journal" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="journal"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="journalSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="typeNameImgShow = !typeNameImgShow">
                                <p class="saixuan_tit">TYPE NAME</p>
                                <img :src="typeNameImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="typeNameImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in typeName" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="typeName"
                                        :id="item.id"
                                        :value="item.name"
                                        v-model="typeNameSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div> -->

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="speciesImgShow = !speciesImgShow">
                                <p class="saixuan_tit">
                                    SPECIES
                                </p>
                                <img :src="speciesImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="speciesImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in species" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="species"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="speciesSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="subjectImgShow = !subjectImgShow">
                                <p class="saixuan_tit">
                                    SUBJECT
                                </p>
                                <img :src="subjectImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="subjectImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in subject" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="subject"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="subjectSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="ageImgShow = !ageImgShow">
                                <p class="saixuan_tit">AGE</p>
                                <img :src="ageImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="ageImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="item in age" :key="item.name">
                                    <input
                                        type="checkbox"
                                        class="check_box tui-checkbox"
                                        name="age"
                                        :id="item.id"
                                        :value="item.valueNew"
                                        v-model="ageSingle"
                                    />
                                    <label :for="item.id" class="checkbox_title">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="btn_search_face">
                            <button class="btn" @click="clearSearchLeft">
                                清空
                            </button>
                            <button class="btn" @click="createSearchList">
                                检索
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </md-popup>
        <!--右侧排序菜单-->
        <md-popup v-model="isPopupShow.right" position="right">
            <div class="md-example-popup md-example-popup-left dempo_box">
                <div class="dempo">
                    <div class="left-title">过滤</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title">CiteScore</div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="CiteScore"
                                    id="CiteScoreA"
                                    value="1-50+"
                                    v-model="CiteScoreSingle"
                                />
                                <label for="CiteScoreA" class="checkbox_title">CiteScore > 1.0</label>
                            </div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="CiteScore"
                                    id="CiteScoreB"
                                    value="5-50+"
                                    v-model="CiteScoreSingle"
                                />
                                <label for="CiteScoreB" class="checkbox_title">CiteScore > 5.0</label>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title">TC FILTER</div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="filter"
                                    id="tcfilterA"
                                    value="1-50+"
                                    v-model="filterSingle"
                                />
                                <label for="tcfilterA" class="checkbox_title">TC > 1</label>
                            </div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="filter"
                                    id="tcfilterB"
                                    value="10-50+"
                                    v-model="filterSingle"
                                />
                                <label for="tcfilterB" class="checkbox_title">TC > 10</label>
                            </div>
                        </div>

                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title">AREA FILTER</div>
                            <div class="checkbox_list">
                                <input type="checkbox" class="check_box tui-checkbox" name="area" id="area" value="0" v-model="areaSingle" />
                                <label for="area" class="checkbox_title">无分区</label>
                            </div>
                            <div class="checkbox_list">
                                <input type="checkbox" class="check_box tui-checkbox" name="area" id="areaA" value="1" v-model="areaSingle" />
                                <label for="areaA" class="checkbox_title">1区</label>
                            </div>
                            <div class="checkbox_list">
                                <input type="checkbox" class="check_box tui-checkbox" name="area" id="areaB" value="2" v-model="areaSingle" />
                                <label for="areaB" class="checkbox_title">2区</label>
                            </div>
                            <div class="checkbox_list">
                                <input type="checkbox" class="check_box tui-checkbox" name="area" id="areaC" value="3" v-model="areaSingle" />
                                <label for="areaC" class="checkbox_title">3区</label>
                            </div>
                            <div class="checkbox_list">
                                <input type="checkbox" class="check_box tui-checkbox" name="area" id="areaD" value="4" v-model="areaSingle" />
                                <label for="areaD" class="checkbox_title">4区</label>
                            </div>
                        </div>
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title">SORT</div>
                            <div class="checkbox_list">
                                <input type="radio" class="check_box tui-checkbox dan" name="sort" id="sortA" value="" v-model="sortSingle" />
                                <label for="sortA" class="checkbox_title">Best Match</label>
                            </div>
                            <div class="checkbox_list">
                                <input type="radio" class="check_box tui-checkbox dan" name="sort" id="sortB" value="date" v-model="sortSingle" />
                                <label for="sortB" class="checkbox_title">Most Recent</label>
                            </div>
                        </div>

                        <div class="btn_search_face_right">
                            <button class="btn" @click="clearSearchRight">
                                清空
                            </button>
                            <button class="btn" @click="createSearchList('right')">
                                检索
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </md-popup>

        <!-- 添加跟踪式检索 -->
        <md-popup v-model="isFollowShow">
            <div class="md-example-popup md-example-popup-center md-example-popup-follow ">
                <h3>
                    跟踪式检索信息
                    <!-- <div class="md-example-child md-example-child-icon md-example-child-icon-0">
                <div class="md-example-item">
                    <md-icon name="world" size="lg"></md-icon>
                </div>
            </div> -->
                </h3>
                <p>
                    您将创建一个对此检索式的跟踪，当您需要查看此检索式否有新文章式可以在“我的”下“我跟踪的检索式”里面查看更新，请对现在创建跟踪的检索式起个名字，并作详细的描述。
                </p>
                <div>
                    <input type="text" placeholder="请输入名称" v-model="followName" />
                    <textarea name="" id="" cols="30" rows="10" v-model="followNotesJss" placeholder="请输入描述"></textarea>
                </div>
                <div class="md-example-child  md-example-child-button md-example-child-button-3">
                    <div class="md-example-section" style="text-align:right">
                        <md-button type="primary" inline style="margin-right:10px" @click="followDetermine()">确认</md-button>
                        <md-button type="primary" inline plain @click="folderFollow()">取消</md-button>
                    </div>
                </div>
            </div>
        </md-popup>

        <van-popup v-model="isPopupShow.bottoms" position="bottom" :style="{ height: '30%' }">
            <van-datetime-picker
                v-model="currentDates"
                type="date"
                title="选择年月日"
                @confirm="startconfirm"
                @cancel="isPopupShow.bottoms = false"
                :min-date="minDates"
                :max-date="maxDates"
            />
        </van-popup>
        <van-popup v-model="isPopupShow.bottome" position="bottom" :style="{ height: '30%' }">
            <van-datetime-picker
                v-model="currentDatee"
                type="date"
                title="选择年月日"
                @confirm="endconfirm"
                @cancel="isPopupShow.bottome = false"
                :min-date="minDatee"
                :max-date="maxDatee"
            />
        </van-popup>
        <!-- <md-popup v-model="isPopupShow.bottome" position="bottom">
            <md-popup-title-bar title="Popup Title" describe="Popup Description" ok-text="ok" cancel-text="cancel" large-radius></md-popup-title-bar>
            <md-date-picker
                ref="datePicker"
                today-text="今天"
                :min-date="minDatee"
                :max-date="maxDatee"
                :default-date="currentDatee"
                is-view
                @initialed="onDatePickerInitialed"
            ></md-date-picker>
        </md-popup> -->
    </div>
</template>

<script>
import searchpub from "../../components/pubmedsearch";
import upImg from "../../assets/img/up.png";
import downImg from "../../assets/img/down.png";
import api from "../../request/api/pubmedApi.js";

import {
    Button,
    Popup,
    PopupTitleBar,
    DropMenu,
    Field,
    CheckList,
    Icon,
    ActivityIndicator,
    Check,
    CheckBox,
    CheckGroup,
    Radio,
    Toast,
    DatePicker
} from "mand-mobile";

export default {
    components: {
        searchpub,
        [Toast.name]: Toast,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
        [DropMenu.name]: DropMenu,
        [Field.name]: Field,
        [CheckList.name]: CheckList,
        [Icon.name]: Icon,
        [ActivityIndicator.name]: ActivityIndicator,
        [Check.name]: Check,
        [CheckBox.name]: CheckBox,
        [CheckGroup.name]: CheckGroup,
        [Radio.name]: Radio,
        [DatePicker.name]: DatePicker
    },
    name: "pubsearchlist",
    data() {
        return {
            yanNull: true,
            type: "search",
            data: [],
            searchType: this.$route.query.type,
            finished: false,
            loading: false,
            count: 0,
            searchVal: this.$route.query.val,
            term: "",
            pmidListKey: this.$route.query.key || "",
            /*左右侧弹出*/
            isPopupShow: {
                left: false,
                right: false,
                bottoms: false,
                bottome: false
            },
            /* 跟踪检索式按钮显示隐藏 */
            folderFollowBtn: false,
            /* 跟踪检索式弹出层 */
            isFollowShow: false,
            followName: "",
            followNotesJss: "",
            //左侧分类检索数据
            language: [],
            articleAttribute: [],
            sex: [],
            journal: [],
            typeName: [],
            species: [],
            subject: [],
            publicationDate: [],
            textAvailability: [],
            articleType: [],
            age: [],
            //左侧分类检索选中数据
            languageSingle: [],
            articleAttributeSingle: [],
            sexSingle: [],
            journalSingle: [],
            typeNameSingle: [],
            speciesSingle: [],
            subjectSingle: [],
            publicationDateSingle: "",
            textAvailabilitySingle: [],
            articleTypeSingle: [],
            ageSingle: [],
            //右侧
            CiteScoreSingle: "",
            filterSingle: "",
            areaSingle: [],
            sortSingle: "",
            //左侧菜单的显示隐藏
            selectYearShow: false,
            selectTypeShow: false,
            selectWOSShow: false,
            up: upImg,
            down: downImg,
            //图片的切换
            languageImgShow: false,
            articleAttributeImgShow: false,
            sexImgShow: false,
            journalImgShow: false,
            typeNameImgShow: false,
            speciesImgShow: false,
            subjectImgShow: false,
            publicationDateImgShow: false,
            textAvailabilityImgShow: false,
            articleTypeImgShow: false,
            ageImgShow: false,
            contentId: "",
            detailsArr: "",
            flag: "",
            detailsType: "",
            toTest: "",
            page: 2,
            num: "",
            reKey: "",
            dateShow: false,
            minDates: new Date("1980/1/1"),
            maxDates: new Date(),
            currentDates: new Date(),
            minDatee: new Date("1980/1/1"),
            maxDatee: new Date(),
            currentDatee: new Date(),
            yearStart: "",
            yearEnd: ""
        };
    },
    created() {},
    mounted() {
        ///search/filter
        this.$store.dispatch("actionsHead", { type: true, title: "", iconType: true });
        api.pubMedFilter("").then((res) => {
            if (res.code === 0) {
                this.language = res.data["LANGUAGE"];
                this.articleAttribute = res.data["ARTICLE ATTRIBUTE"];
                this.sex = res.data["SEX"];
                this.journal = res.data["JOURNAL"];
                this.typeName = res.data["typeName"];
                this.species = res.data["SPECIES"];
                this.subject = res.data["SUBJECT"];
                this.publicationDate = res.data["PUBLICATION DATE"];
                this.textAvailability = res.data["TEXT AVAILABILITY"];
                this.articleType = res.data["ARTICLE TYPE"];
                this.age = res.data["AGE"];
                if (!this.$route.query.followId) {
                    this.$refs.child.pubmedSearch();
                }
            }
        });

        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                that.loadMore();
            }
        };
    },
    methods: {
        // showPopUp(type) {
        //     // this.$set(this.isPopupShow1, type, true);
        //     this.isPopupShow.button = true;
        // },
        startconfirm(value) {
            this.yearStart = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.isPopupShow.bottoms = false;
            this.minDatee = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        endconfirm(value) {
            this.yearEnd = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.isPopupShow.bottome = false;
            this.maxDates = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        viewDescription(pid) {
            api.pubMedListCkzy({ pmid: pid }).then((res) => {
                if (res.code === 0) {
                    this.detailsType = "viewDescription";
                    this.contentId = pid;
                    this.detailsArr = res.data.abstractText;
                }
            });
        },
        journalBlock(pid, type) {
            api.pubMedListJour({ pmid: pid, type: type }).then((res) => {
                if (res.code === 0) {
                    this.detailsType = type;
                    this.contentId = pid;
                    this.detailsArr = res.data.result;
                    this.flag = res.data.flag;
                }
            });
        },
        ApplicationFullText(index) {
            // api.pubMedFolderAddcases({ pmids: pid }).then((res) => {
            //     if (res.code === 0) {
            //         this.contentId = pid;
            //         this.detailsType = "ApplicationFullText";
            //         this.toTest = "申请成功！请到我的文档中查看！";
            //     } else {
            //         this.toTest = "申请失败！请联系管理员或稍后再试！";
            //     }
            // });
            var data = this.data;
            api.pubMedCasesAdd([
                {
                    title: data[index].title,
                    author: data[index].authorls,
                    sourcefrom: data[index].source,
                    year: data[index].year,
                    doi: data[index].doi,
                    web: data[index].pmid == "0" ? 8 : 1,
                    url: data[index].url,
                    pmid: data[index].pmid,
                    myid: data[index].et,
                    jid: data[index].jid,
                    pmidNcNlmId: data[index].jid,
                    sourcecode: "hexin"
                }
            ]).then((res) => {
                if (res.code === 0) {
                    this.contentId = data[index].pmid;
                    this.detailsType = "ApplicationFullText";
                    this.toTest = "申请成功！请到我的文档中查看！";
                } else {
                    this.toTest = "申请失败！请联系管理员或稍后再试！";
                }
            });
        },
        //清空检索条件--左侧
        clearSearchLeft() {
            this.languageSingle = [];
            this.articleAttributeSingle = [];
            this.sexSingle = [];
            this.journalSingle = [];
            this.typeNameSingle = [];
            this.speciesSingle = [];
            this.subjectSingle = [];
            this.publicationDateSingle = "";
            this.textAvailabilitySingle = [];
            this.articleTypeSingle = [];
            this.ageSingle = [];
            this.textAvailabilityImgShow = false;
            this.articleAttributeImgShow = false;
            this.articleAttributeImgShow = false;
            this.languageImgShow = false;
            this.articleTypeImgShow = false;
            this.publicationDateImgShow = false;
            this.sexImgShow = false;
            this.journalImgShow = false;
            // this.typeNameImgShow = false;
            this.speciesImgShow = false;
            this.subjectImgShow = false;
            this.ageImgShow = false;
        },
        //清空检索条件--左侧
        clearSearchRight() {
            this.CiteScoreSingle = "";
            this.filterSingle = "";
            this.areaSingle = [];
            this.sortSingle = "";
        },
        //分面检索
        createSearchList(type) {
            let params = "";
            if (this.languageSingle.length !== 0) {
                params = this.languageSingle;
            }
            if (this.articleAttributeSingle.length !== 0) {
                params += "," + this.articleAttributeSingle;
            }
            if (this.sexSingle.length !== 0) {
                params += "," + this.sexSingle;
            }
            if (this.journalSingle.length !== 0) {
                params += "," + this.journalSingle;
            }
            if (this.typeNameSingle.length !== 0) {
                params += "," + this.typeNameSingle;
            }
            if (this.speciesSingle.length !== 0) {
                params += "," + this.speciesSingle;
            }
            if (this.subjectSingle.length !== 0) {
                params += "," + this.subjectSingle;
            }
            if (this.textAvailabilitySingle.length !== 0) {
                params += "," + this.textAvailabilitySingle;
            }
            if (this.articleTypeSingle.length !== 0) {
                params += "," + this.articleTypeSingle;
            }
            if (this.ageSingle.length !== 0) {
                params += "," + this.ageSingle;
            }
            if (this.publicationDateSingle.length !== 0) {
                params += "," + this.publicationDateSingle;
                if (this.yearStart != "" && this.yearEnd != "") {
                    params += this.yearStart + " - " + this.yearEnd;
                }
            }
            if (params[0] === ",") {
                params = params.slice(1);
            }
            let formData = new FormData();
            formData.append("alt", "");
            let key = "";
            if (this.searchType === "All") {
                key = this.searchVal;
                // key = this.term;
            } else {
                key = this.searchVal + "[" + this.searchType + "]";
                // key = this.term + "[" + this.searchType + "]";
            }

            let fenqu = "";
            if (this.areaSingle.length !== 0) {
                fenqu = this.areaSingle.toString();
            }

            formData.append("term", key);
            formData.append("exclude", 0);
            formData.append("fenqu", fenqu);
            formData.append("filter", params.toString());
            formData.append("format", "");
            formData.append("impact", this.CiteScoreSingle);
            formData.append("jabbr", "");
            formData.append("leftNum", "");
            formData.append("num", this.num);
            formData.append("page", 1);
            formData.append("pmidListIndex", 0);
            formData.append("pmidListKey", this.pmidListKey);
            formData.append("reKey", this.reKey);
            formData.append("size", 10);
            formData.append("sjr", "");
            formData.append("sort", this.sortSingle);
            formData.append("total", this.filterSingle);
            if (this.num > 30000 && type === "right") {
                Toast.info("总条数超过30000！");
            } else {
                api.pubMedSearch(formData).then((res) => {
                    if (res.code === 0) {
                        this.isPopupShow.left = false;
                        this.isPopupShow.right = false;
                        this.data = res.data.list;
                        this.num = res.data["num"];
                        this.count = res.data.num ? res.data.num : 0;
                        if (res.data.list) {
                            this.yanNull = true;
                        } else {
                            this.yanNull = false;
                        }
                    } else {
                        Toast.info(res.msg);
                    }
                });
            }
        },
        listenToMyBoy(e) {
            //检索的数据
            this.data = e.list;
            this.count = e.num;
            this.num = e.num;
            this.folderFollowBtn = e.num < 3000 ? true : false;
            this.reKey = e.rekey;
            this.searchVal = e.term;
            if (this.data) {
                this.yanNull = true;
            } else {
                this.yanNull = false;
            }
            this.clearSearchLeft();
        },
        listenVal(e) {
            this.searchVal = e;
        },
        listenType(e) {
            this.searchType = e;
        },
        showPopUp: function(type) {
            //给属性设置属性或者修改属性 ---实例创建后存在的属性。
            this.isPopupShow[type] = !this.isPopupShow[type];
            // this.$set(this.isPopupShow, type, true)
        },
        folderFollow: function() {
            this.isFollowShow = !this.isFollowShow;
        },
        followDetermine() {
            let Data = new FormData();
            Data.append("reKey", this.reKey);
            Data.append("name", this.followName), Data.append("notes", this.followNotesJss);

            // Data.reKey = this.reKey;
            // Data.name = this.followName;
            // Data.notes = this.followNotesJss;
            api.pubMedFolderFollow(Data).then((res) => {
                if (res["code"] == 0) {
                    Toast.succeed("跟踪检索式成功,请在‘我的’-‘我跟踪的检索式’中查看");
                    this.isFollowShow = false;
                }
            });
            //  var ccParam='';
            //     if(!pmidListKey){
            //         ccParam = param;
            //     }
            //     var ajaxTimeOut =
            //      $.ajax({
            //         url: publicUrl + "/folder/follow",
            //         type: 'post',
            //         dataType: 'json',
            //         async: true,//异步
            //         timeout: TIMEOUTDATE,
            //         xhrFields: { withCredentials: true },//跨域
            //         data: {
            //             reKey:reKey,
            //             name: nameJss,//名字
            //             notes: notesJss,//备注
            //         },
            //         complete: function (XMLHttpRequest, status) {
            //             if (status == 'timeout') {
            //                 ajaxTimeOut.abort();
            //                 layer.close(index);
            //                 layer.confirm('抱歉，请求超时', {
            //                     btn: ['重试'] //按钮
            //                 }, function () {
            //                     jssAjax();
            //                 });
            //             }
            //         },
            //         success: function (data) {
            //             if (data['code'] == 0) {
            //                 layer.msg("跟踪检索式成功,请在‘个人中心’-‘我跟踪的检索式’中查看", {
            //                     icon: 1,
            //                 });
            //             }
            //         }
            //     });
        },

        //上拉加载
        loadMore() {
            if (this.$route.name === "pubsearchlist") {
                if (this.data.length !== 0) {
                    let params = "";
                    if (this.languageSingle.length !== 0) {
                        params = this.languageSingle;
                    }
                    if (this.articleAttributeSingle.length !== 0) {
                        params += "," + this.articleAttributeSingle;
                    }
                    if (this.sexSingle.length !== 0) {
                        params += "," + this.sexSingle;
                    }
                    if (this.journalSingle.length !== 0) {
                        params += "," + this.journalSingle;
                    }
                    if (this.typeNameSingle.length !== 0) {
                        params += "," + this.typeNameSingle;
                    }
                    if (this.speciesSingle.length !== 0) {
                        params += "," + this.speciesSingle;
                    }
                    if (this.subjectSingle.length !== 0) {
                        params += "," + this.subjectSingle;
                    }
                    if (this.textAvailabilitySingle.length !== 0) {
                        params += "," + this.textAvailabilitySingle;
                    }
                    if (this.articleTypeSingle.length !== 0) {
                        params += "," + this.articleTypeSingle;
                    }
                    if (this.ageSingle.length !== 0) {
                        params += "," + this.ageSingle;
                    }
                    if (this.publicationDateSingle.length !== 0) {
                        params += "," + this.publicationDateSingle;
                    }
                    if (params[0] === ",") {
                        params = params.slice(1);
                    }
                    let formData = new FormData();
                    formData.append("alt", "");
                    let key = "";
                    if (this.searchType === "All") {
                        key = this.searchVal;
                    } else {
                        key = this.searchVal + "[" + this.searchType + "]";
                    }

                    let fenqu = "";
                    if (this.areaSingle.length !== 0) {
                        fenqu = this.areaSingle.toString();
                    }
                    formData.append("term", key);
                    formData.append("exclude", 0);
                    formData.append("fenqu", fenqu);
                    formData.append("filter", params);
                    formData.append("format", "");
                    formData.append("impact", this.CiteScoreSingle);
                    formData.append("jabbr", "");
                    formData.append("leftNum", "");
                    formData.append("num", this.num);
                    formData.append("page", this.page++);
                    formData.append("pmidListIndex", "");
                    formData.append("pmidListKey", this.pmidListKey);
                    formData.append("reKey", "");
                    formData.append("size", 10);
                    formData.append("sjr", "");
                    formData.append("sort", this.sortSingle);
                    formData.append("total", this.filterSingle);
                    api.pubMedSearch(formData).then((res) => {
                        // console.log(res)
                        this.isPopupShow.left = false;
                        this.data = this.data.concat(res.data.list);
                        this.count = res.data.num ? res.data.num : 0;
                        this.num = res.data["num"];
                        if (res.data.list) {
                            this.loading = false;
                            this.finished = true;
                            this.yanNull = true;
                        } else {
                            this.yanNull = false;
                        }
                    });
                }
            }
        },
        seloctorYearList: function() {
            this.selectYearShow = !this.selectYearShow;
        }
    },
    watch: {
        publicationDateSingle(newVal, oldVal) {
            oldVal;
            if (newVal == "dates.") {
                this.dateShow = true;
            } else {
                this.dateShow = false;
            }
        }
    }
};
</script>

<style>
.adv {
    margin: -10px auto 20px;
    display: block;
    width: 100%;
    text-align: center;
    color: #168bc1;
}

.search_list {
    width: 97%;
    margin: 0 auto;
    height: auto;
    display: table;
}

.count {
    font-size: 16px;
    line-height: 40px;
}

.title,
.author {
    font-size: 16px;
    line-height: 27px;
}

.title {
    font-size: 19px;
    font-weight: bold;
}

.title b {
    color: #168bc1;
}

.search_single {
    padding: 10px 0;
    border-bottom: 1px solid #ededed;
}

/*左侧AND右侧弹出菜单样式*/
.md-cell-item-body {
    padding: 0;
    font-size: 16px;
    min-height: 60px;
}

.md-cell-item-body p {
    font-size: 16px;
}

/*
        .select-title-box > div:nth-child(2) > div > div {
            padding: 0;
            min-height: 60px;

        div p.md-cell-item-title {
            font-size: 16px !important;
            line-height: 30px !important;
        }
        }
    */
.selectDemo {
    border-bottom: 1px solid #ededed;
}

.selectDemo .md-check-icon i,
.selectDemo .md-radio-icon i {
    font-size: 23px !important;
}

.md-icon {
    top: -2px !important;
    right: -0.933rem !important;
}

.md-check-label,
.md-radio-label {
    margin-left: 1.64rem !important;
}

.dempo {
    margin-top: 10px;
    width: 95%;
    padding: 15px 2% 4rem 2%;
    text-align: left;
}

.left-title {
    line-height: 40px;
    font-size: 24px;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.select-title {
    width: 100%;
    position: relative;
    cursor: pointer;
    /*height: 40px;*/
    height: auto;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    display: table;
}

.saixuan_tit {
    width: 90%;
    float: left;
}

.md-example-child-popup-0 {
    float: left;
    width: 100%;
}

.md-button {
    margin-bottom: 20px;
}

.md-field {
    padding: 0;
}

.hold {
    font-weight: bold;
}

.md-example-popup {
    position: relative;
    font-size: 16px;
    font-family: DINPro;
    font-weight: 500;
    box-sizing: border-box;
    text-align: center;
    background-color: #fff;
}

.md-example-popup-follow {
    padding: 0 0 20px;
    text-align: left;
}

.md-example-popup-follow > h3 {
    background-color: #f9f9f9;
    padding: 10px 20px;
    font-size: 20px;
}

.md-example-popup-follow > p {
    padding: 10px 20px;
    line-height: 150%;
}

.md-example-popup-follow > p::after {
    content: "";
    display: block;
    width: 100%;
    border-bottom: 1px dashed #d3d3d3;
    margin: 20px 0 5px;
}

.md-example-popup-follow > div {
    width: 100%;
    padding: 0 20px;
}

.md-example-popup-follow > div input,
.md-example-popup-follow > div textarea {
    width: 100%;
    border: 1px solid #d3d3d3;
    padding: 10px;
    font-size: 14px;
}

.md-example-popup-follow > div textarea {
    margin-top: 10px;
}

.md-example-popup-follow button {
    width: 70px;
    height: 35px;
    font-size: 16px;
    margin-top: 10px;
}

.md-example-popup-top {
    width: 100%;
    height: 75px;
    line-height: 75px;
    background: #4a4c5b;
    color: #fff;
}

.md-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

.md-icon.icon-font.lg {
    font-size: 1.24rem;
}

.md-example-popup-bottom {
    width: 100%;
    padding: 100px 0;
}

.md-example-popup-bottom p {
    line-height: 50px;
}

.md-example-popup-left,
.md-example-popup-right {
    height: 100%;
    width: 250px;
    display: flex;
}

.md-example-popup-left,
.md-example-popup-right {
    height: auto;
}

.caozuo {
    width: 90%;
    display: table;
    margin: 5px auto auto auto;
    line-height: 35px;
    font-size: 16px;
}

.caozuo span {
    display: table;
    float: left;
    width: 24%;
    text-align: center;
    color: #168bc1;
}

.top {
    height: 45px;
    width: 100%;
}

.top-list {
    /* border-bottom: 0.005rem solid #e5e5e5;*/ /* no */
    display: flex;
    width: 100%;
    height: 45px;
}

.group {
    border-right: 0.005rem solid #e5e5e5; /*no*/
}

.top-list li {
    border: 1px solid #e3e3e3;
    height: 45px;
    font-size: 16px;
    line-height: 45px;
    text-align: center;
    color: #2d5459;
    width: 50%;
}

.top-list li.isLi {
    width: 25%;
}

.top-list .follow {
    background-color: #40a3fb;
    border-color: #40a3fb;
    color: #fff;
    width: 49%;
    margin-left: 0.2rem;
}

.top-list li img {
    vertical-align: middle;
    width: 1rem;
}

.tui-checkbox:checked {
    background: #1673ff;
    border: solid 1px #1673ff;
}

.tui-checkbox {
    width: 16px;
    height: 16px;
    float: left;
    background-color: #ffffff;
    border: solid 1px #999999;
    -webkit-border-radius: 20%;
    border-radius: 20%;
    font-size: 16px;
    margin-top: 7px;
    padding: 0;
    position: relative;
    display: inline-block;
    vertical-align: top;
    cursor: default;
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-transition: background-color ease 0.6s;
    transition: background-color ease 0.6s;
}

.dan {
    -webkit-border-radius: 50% !important;
    border-radius: 50% !important;
}

.tui-checkbox:checked::after {
    content: "";
    top: 3px;
    left: 3.5px;
    position: absolute;
    background: transparent;
    border: #fff solid 2px;
    border-top: none;
    border-right: none;
    height: 5px;
    width: 5px;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.checkbox_list {
    width: 90%;
    padding-left: 10%;
    height: 30px;
    line-height: 30px;
    display: table;
}

.checkbox_title {
    width: 200px;
    margin-left: 25px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.up_down {
    width: 20px;
    height: 20px;
    float: right;
    display: block;
    margin-top: 10px;
}

.dempo_box {
    position: relative;
    height: 100%;
    display: table;
}

.checkbox_list_single {
    -webkit-transition: 1s;
    transition: 1s;
}
.btn_search_face,
.btn_search_face_right {
    position: fixed;
    bottom: 0rem;
    width: 250px;
    height: 4rem;
    background-color: white;
}

.btn_search_face {
    left: 0;
}

.btn_search_face_right {
    right: 0;
}

.btn_search_face button,
.btn_search_face_right button {
    width: 124.8px;
    float: left;
    height: 40px;
    border: none;
    color: white;
}

.btn_search_face button:nth-child(1),
.btn_search_face_right button:nth-child(1) {
    background-color: #46adcf;
}

.btn_search_face button:nth-child(2),
.btn_search_face_right button:nth-child(2) {
    background-color: #168bc1;
}

.zanwu {
    line-height: 40px;
    text-align: center;
}

.content2 {
    border: 2px solid #168bc1;
    width: 90%;
    margin: 0 auto;
    font-size: 16px;
    padding: 10px 5px;
    border-radius: 10px;
}

.content_single p {
    line-height: 23px;
    font-size: 16px;
    text-indent: 1em;
    word-break: break-word;
}

.content_single .listTabModular {
    font-weight: bold;
    margin: 15px 0px 8px 0px;
    line-height: 18px;
}

.content_single p span:last-child {
    color: #999999;
}

.detailActive {
    background-color: #168bc1;
    color: white !important;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.md-toast-text {
    font-size: 16px;
}

.dateDiv {
    padding-left: 0.5rem;
}

.dateDiv div {
    width: 45%;
    height: 1.5rem;
    line-height: 1.5rem;
    border: 0.05333rem solid #c1c1c1;
    display: inline-block;
    margin: 0 0rem 1rem;
    vertical-align: top;
    text-align: center;
}
</style>
